"use client"

import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { GenericaSistemaService } from '../service/GenericaSistemaService';
import AuthStorage from '../storage/AuthStorage';
import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';
import { setgid } from 'process';


const FileDownload = () => {


    console.log("FileDownload");

    //const search = useLocation().search;
    const [guid, setGuid] = useState(undefined);

    const [cargado, setCargado] = useState(false);

    
    const [authStorage, setAuthStorage] = useState(undefined);

    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;

    const genericaSistemaService = new GenericaSistemaService();

    useEffect(() => {

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        const userDetails = authStorage.GetCurrentUser();
        userName = userDetails.userName;
        idioma = userDetails.idioma;
        idEmpresa = userDetails.idEmpresa;
        sessionGUID = userDetails.sessionGUID
        documentoInvitado = userDetails.documentoInvitado

        setAuthStorage(authStorage);
        const guidParam = new URLSearchParams(window.location.search).get('guid');

        setGuid(guidParam);

        console.log("ingresó");

        LoadFile(guidParam);


    }, [])

    const LoadFile = async (guidParam) => {

        await genericaSistemaService.getDocumentByGuid(idEmpresa, idioma, userName, guidParam).then(response => {
        });


    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Empty Page{cargado}</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
            </div>
        </div>
    );

}


export default FileDownload;
